// Define action types
export const SET_CREATE_BOOKING_RESPONSE = 'SET_CREATE_BOOKING_RESPONSE';

// Define action creators
export const setCreateBookingResponse = (response) => ({
  type: SET_CREATE_BOOKING_RESPONSE,
  payload: response,
});
